<div class="dialog-container">
    <app-inspection-form [showButtons]="false" [scJob]="scJob" (closeevent)="onClose($event)"></app-inspection-form>
</div>